import React from "react";

export default function DroneDashLeaderboard({ game, onClose }) {
  const rows = game.leaderboard || [];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 px-4">
      <div className="w-full max-w-sm rounded-3xl bg-gradient-to-br from-amber-400 via-orange-500 to-rose-500 p-[2px]">
        <div className="rounded-3xl bg-slate-950 p-5 max-h-[80vh] flex flex-col">
          <div className="flex items-center justify-between mb-3">
            <h2 className="text-cyan-200 font-black text-lg">👑 Top Pilots</h2>
            <button onClick={onClose} className="text-xs text-slate-300 border border-slate-700 rounded-lg w-fit px-3 py-1">
              Close
            </button>
          </div>

          {game.loadingLeaderboard && <div className="text-slate-400 text-sm text-center py-6">Loading…</div>}

          {!game.loadingLeaderboard && (
            <div className="space-y-2 overflow-y-auto">
              {rows.length === 0 && (
                <div className="text-slate-500 text-sm text-center py-8">No flights recorded yet — be the first!</div>
              )}
              {rows.map((r) => (
                <div
                  key={r.rank}
                  className="flex items-center justify-between rounded-xl bg-slate-900/80 border border-slate-800 px-3 py-2"
                >
                  <div className="flex items-center gap-2">
                    <span className="text-sm font-black text-amber-400 w-5">{r.rank}</span>
                    <span className="text-sm text-white">{r.name || "Anonymous"}</span>
                  </div>
                  <span className="text-sm font-bold text-cyan-300">{r.score}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
